import { render, staticRenderFns } from "./SettingsClinicalUsers.vue?vue&type=template&id=2c793d66"
import script from "./SettingsClinicalUsers.vue?vue&type=script&lang=js"
export * from "./SettingsClinicalUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports